import {ConnectedComponent} from 'lowkey-component';

import {getAbsoluteTop, sleep} from '@lib/utils';
import {appSelectors} from '@store/appSlice';

const defaultThreshold = 1.0;

export default class ViewportElement extends ConnectedComponent {
  observer: IntersectionObserver | null = null;
  type = '';

  constructor(element: HTMLDivElement) {
    super(element);
    this.onIntersection = this.onIntersection.bind(this);
  }

  isFirstView() {
    const top = getAbsoluteTop(this.element);
    return top < window.innerHeight;
  }

  didMount() {
    if (this.isFirstView()) {
      this.observe(appSelectors.selectSiteIndicatorStatus, async (status) => {
        if (status === 'hidingAnimation') {
          await sleep(100);
          this.element?.classList.add('viewed');
        }
      });
      this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
        if (status === 'startHideAnimation') {
          await sleep(100);
          this.element?.classList.add('viewed');
        }
      });
    } else {
      this.type = this.element.dataset['type'] || '';
      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '0px',
        // threshold: [0, 1],
        threshold: [0, defaultThreshold],
      });
      this.observer.observe(this.element);
    }
  }

  didUnmount() {
    this.observer?.disconnect();
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      // 画面の下でintersectionしたかどうか
      // const isBottomArea = entry.boundingClientRect.top > window.innerHeight / 2
      const isBottomArea = entry.boundingClientRect.top > 0;
      if (isBottomArea) {
        if (!entry.isIntersecting) {
          this.element?.classList.remove('viewed');
        }
        if (
          entry.isIntersecting &&
          entry.intersectionRatio >= defaultThreshold
        ) {
          this.element?.classList.add('viewed');
          if (this.type === 'once') {
            this.observer?.disconnect();
          }
        }
      }
    }
  }
}
